// 专利数据字段枚举
export var E_PATENT_FIELD;
(function (E_PATENT_FIELD) {
    /**
     * 公开公告号
     * */
    E_PATENT_FIELD["PN"] = "PN";
    /**
     * 标题
     * */
    E_PATENT_FIELD["TITLE"] = "TITLE";
    /**
     * 法律状态
     * */
    E_PATENT_FIELD["LEGAL_STATUS"] = "LEGAL_STATUS";
    /**
     * 标当前申请人
     * */
    E_PATENT_FIELD["ANCS"] = "ANCS";
    /**
     * 应用领域分类
     * */
    E_PATENT_FIELD["ADC"] = "ADC";
    /**
     * 申请日
     * */
    E_PATENT_FIELD["APD"] = "APD";
    /**
     * 公开日
     * */
    E_PATENT_FIELD["PBD"] = "PBD";
    /**
     * 注释
     * */
    E_PATENT_FIELD["COMMENT"] = "COMMENT";
    /**
     * 标注的附图
     * */
    E_PATENT_FIELD["IMAGE_COMMENTS_LAB"] = "IMAGE_COMMENTS_LAB";
    /**
     * 代理人
     * */
    E_PATENT_FIELD["AT"] = "AT";
    /**
     * 首次公开日
     * */
    E_PATENT_FIELD["F_PBD"] = "F_PBD";
    /**
     *  保存位置
     */
    E_PATENT_FIELD["SAVED_TO_WORKSPACE"] = "SAVED_TO_WORKSPACE";
    /**
     *  原始申请(专利权)人
     */
    E_PATENT_FIELD["AN"] = "AN";
    /**
     *  当前申请(专利权)人
     */
    E_PATENT_FIELD["ANC"] = "ANC";
    /**
     *  [标]当前申请(专利权)人
     */
    E_PATENT_FIELD["ANC_ADD"] = "ANC_ADD";
    /**
     *  [标]原始申请(专利权)人
     */
    E_PATENT_FIELD["ANS"] = "ANS";
    /**
     *  申请日
     */
    E_PATENT_FIELD["APN"] = "APN";
    /**
     *  代理机构
     */
    E_PATENT_FIELD["ATC"] = "ATC";
    /**
     *  被引用专利数量
     */
    E_PATENT_FIELD["CITED_COUNT"] = "CITED_COUNT";
    /**
     *  权利要求数
     */
    E_PATENT_FIELD["CLAIM_COUNT"] = "CLAIM_COUNT";
    /**
     *  CPC分类号
     */
    E_PATENT_FIELD["CPC"] = "CPC";
    /**
     *  官方/预测CPC分类号
     */
    E_PATENT_FIELD["CPC_ALL"] = "CPC_ALL";
    /**
     *  预估到期日
     */
    E_PATENT_FIELD["EXDT"] = "EXDT";
    /**
     *  FI分类号
     */
    E_PATENT_FIELD["FI"] = "FI";
    /**
     *  F-TERM分类号
     */
    E_PATENT_FIELD["FTERM"] = "FTERM";
    /**
     *  发明人
     */
    E_PATENT_FIELD["IN"] = "IN";
    /**
     *  IPC分类号
     */
    E_PATENT_FIELD["IPC"] = "IPC";
    /**
     *  授权日
     */
    E_PATENT_FIELD["ISD"] = "ISD";
    /**
     *  LOC分类号
     */
    E_PATENT_FIELD["LOC"] = "LOC";
    /**
     *  专利类型
     */
    E_PATENT_FIELD["PATENT_TYPE"] = "PATENT_TYPE";
    /**
     *  优先权
     */
    E_PATENT_FIELD["PRIORITY"] = "PRIORITY";
    /**
     *  专利价值（美元）
     */
    E_PATENT_FIELD["PV"] = "PV";
    /**
     *  UPC分类号
     */
    E_PATENT_FIELD["UPC"] = "UPC";
    /**
     *  引用专利数量
     */
    E_PATENT_FIELD["CITE_COUNT"] = "CITE_COUNT";
    /**
     *  简单同族专利申请数量
     */
    E_PATENT_FIELD["SIMPLE_FAMILY_COUNT"] = "SIMPLE_FAMILY_COUNT";
    /**
     *  Patsnap同族专利申请数量
     */
    E_PATENT_FIELD["EXTEND_FAMILY_COUNT"] = "EXTEND_FAMILY_COUNT";
    /**
     *  INPADOC同族专利申请数量
     */
    E_PATENT_FIELD["INPADOC_FAMILY_COUNT"] = "INPADOC_FAMILY_COUNT";
    /**
     *  收录时间
     */
    E_PATENT_FIELD["WS_CREATED_AT"] = "WS_CREATED_AT";
    /**
     *  PatSnap同族国家/地区
     */
    E_PATENT_FIELD["EFAM_COUNTRY"] = "EFAM_COUNTRY";
    /**
     *  国民经济行业分类号
     */
    E_PATENT_FIELD["GBC"] = "GBC";
    /**
     *  第一权利要求
     */
    E_PATENT_FIELD["MCLMS"] = "MCLMS";
    /**
     *  简单同族国家/地区
     */
    E_PATENT_FIELD["SIMPLE_FAMILY_COUNTRY"] = "SIMPLE_FAMILY_COUNTRY";
    /**
     *  摘要附图
     */
    E_PATENT_FIELD["THUMB_120"] = "THUMB_120";
    /**
     *  被分配者
     */
    E_PATENT_FIELD["WS_ASSIGN_TO"] = "WS_ASSIGN_TO";
    /**
     *  命中序列（公开位置）
     */
    E_PATENT_FIELD["TARGET_SEQUENCE"] = "TARGET_SEQUENCE";
    /**
     *  搜索名称
     */
    E_PATENT_FIELD["TARGET_SEQUENCE_QUERY"] = "TARGET_SEQUENCE_QUERY";
    /**
     *  命中序列（权利要求公开）
     */
    E_PATENT_FIELD["TARGET_SEQUENCE_CLAIM"] = "TARGET_SEQUENCE_CLAIM";
    /**
     *  命中序列位置（权利要求公开）
     */
    E_PATENT_FIELD["TARGET_SEQUENCE_CLAIM_POSITION"] = "TARGET_SEQUENCE_CLAIM_POSITION";
    /**
     *  命中序列描述（权利要求公开）
     */
    E_PATENT_FIELD["TARGET_SEQUENCE_CLAIM_TEXT"] = "TARGET_SEQUENCE_CLAIM_TEXT";
    /**
     *  技术功效语段
     */
    E_PATENT_FIELD["EFFICIENCY_SENTENCE"] = "EFFICIENCY_SENTENCE";
    /**
     *  产品
     */
    E_PATENT_FIELD["VPM_ED"] = "VPM_ED";
    /**
     *  技术主题分类
     */
    E_PATENT_FIELD["TTC"] = "TTC";
    /**
     *  战略新兴产业分类(主分类)
     */
    E_PATENT_FIELD["SEIC"] = "SEIC";
    /**
     *  战略新兴产业分类
     */
    E_PATENT_FIELD["SEIC_ALL"] = "SEIC_ALL";
    /**
     *  新能源汽车行业分类
     */
    E_PATENT_FIELD["NEV"] = "NEV";
    /**
     *  失效日
     */
    E_PATENT_FIELD["EXPD"] = "EXPD";
    /**
     *  化学结构式
     */
    E_PATENT_FIELD["CHEMICAL_STRUCTURE"] = "CHEMICAL_STRUCTURE";
    /**
     *  IPC主分类号
     */
    E_PATENT_FIELD["IPC_M"] = "IPC_M";
    /**
     *  CPC主分类号
     */
    E_PATENT_FIELD["CPC_M"] = "CPC_M";
    /**
     *  非专利引文数量
     */
    E_PATENT_FIELD["OREF_COUNT"] = "OREF_COUNT";
    /**
     *  专利保护药物
     */
    E_PATENT_FIELD["PHS_PATENTED_DRUG"] = "PHS_PATENTED_DRUG";
    /**
     *  专利分类
     */
    E_PATENT_FIELD["PHS_CORE_TYPE_ID"] = "PHS_CORE_TYPE_ID";
    /**
     *  信息源
     */
    E_PATENT_FIELD["PHS_CORE_DRUG_SOURCE"] = "PHS_CORE_DRUG_SOURCE";
    /**
     *  简单同族编号
     */
    E_PATENT_FIELD["FAMILY_ID"] = "FAMILY_ID";
    /**
     *  INPADOC 同族编号
     */
    E_PATENT_FIELD["INPADOC_FAMILY_ID"] = "INPADOC_FAMILY_ID";
    /**
     *  Patsnap 同族编
     */
    E_PATENT_FIELD["EXTEND_FAMILY_ID"] = "EXTEND_FAMILY_ID";
})(E_PATENT_FIELD || (E_PATENT_FIELD = {}));
